// Reserve a tab during the user's click, before asynchronous checkout requests.
// This helper is only called for authenticated chat embeds.
export class McpBillingWindow {
  private tab: Window | null = null;

  prepare(): void {
    this.cancel();
    try {
      this.tab = window.open('about:blank', '_blank');
      if (this.tab) {
        this.tab.opener = null;
        this.tab.document.title = 'Opening secure checkout';
        this.tab.document.body.textContent = 'Preparing secure checkout… Please wait.';
      }
    } catch { this.cancel(); }
  }

  open(url: string): boolean {
    const tab = this.tab;
    this.tab = null;
    if (!tab || tab.closed) return false;
    try { tab.location.replace(url); return true; }
    catch { try { tab.close(); } catch {} return false; }
  }

  cancel(): void {
    try { this.tab?.close(); } catch {}
    this.tab = null;
  }
}
